const translations = {
  fr: {
    general: {
      menu: {
        programmingSection: 'Espace programmation',
        dashboard: 'Tableau de bord',
        reach: 'Portée',
        listeningTime: 'Temps d\'écoute',
        demography: 'Démographie',
        geolocation: 'Géolocalisation',
        salesSection: 'Espace ventes',
        estimations: 'Estimations',
        summary: 'Sommaire',
        campaigns: 'Campagnes',
        allCampaigns: 'Toutes les campagnes',
        customers: 'Clients',
        allCustomers: 'Tous les clients',
        administration: 'Gestion',
        userManagement: 'Gestion des utilisateurs',
        tutorials: 'Tutoriels',
        inventory: 'Inventaire',
        promotions: 'Promotions',
        configuration: 'Configuration',
        radioConfiguration: 'Configurer la radio',
        salesInventory: 'Inventaire des ventes',
        survey: 'Sondage',
        history: 'Historique',
        propositions: 'Propositions',
        demoCampaign: 'Campagne-démo',
        spots: 'Spots',
        statsRadioAdministration: 'StatsRadio',
        invoicing: 'Facturation',
        technical: 'Technique',
        streams: 'Streams',
      },
      cannotAccessStation: 'Vous n\'avez pas de droits d\'accès pour cette station',
    },
  },
  en: {
    general: {
      menu: {
        programmingSection: 'Programming',
        dashboard: 'Dashboard',
        reach: 'Reach',
        listeningTime: 'Listening Time',
        demography: 'Demography',
        geolocation: 'Geolocation',
        salesSection: 'Sales',
        estimations: 'Estimations',
        inventory: 'Inventory',
        summary: 'Summary',
        campaigns: 'Campaigns',
        allCampaigns: 'All Campaigns',
        customers: 'Customers',
        allCustomers: 'All Customers',
        administration: 'Administration',
        userManagement: 'User Management',
        tutorials: 'Tutorials',
        promotions: 'Promotions',
        configuration: 'Configuration',
        radioConfiguration: 'Configuration de la radio',
        salesInventory: 'Sales inventory',
        survey: 'Survey',
        history: 'History',
        propositions: 'Proposals',
        demoCampaign: 'Demo Campaign',
        spots: 'Spots',
        statsRadioAdministration: 'StatsRadio',
        invoicing: 'Invoicing',
        technical: 'Technical',
        streams: 'Streams',
      },
      cannotAccessStation: 'You do not have access rights for this station',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/i18n/general.js